export default __webpack_public_path__ + "static/media/KidsVideos.b0fe4f1ea08f79bf85de37d7087f7193.webp";